export const customerLogos = ['ups.svg', 'dhl.svg', 'fedex.svg', 'cma.svg'];
